import { defineAction } from '~/prix'
import { z } from 'zod'
import ruralPropertyActivityDeleteAction from './ruralPropertyActivityDelete.action.json' with { type: 'json' }

const ruralPropertyActivityDeleteDefinition = defineAction({
  ...ruralPropertyActivityDeleteAction,
  input: z.object({
    id: z.string().uuid(),
  }),
  output: z.object({}),
})

export default ruralPropertyActivityDeleteDefinition
